import './BlogSection.scss';
import BlogCard from '../../components/BlogCard/BlogCard';
import Button from '../../components/Button/Button';

function BlogSection({ data, currentPage, totalPages, handlePrev, handleNext }) {
  return (
    <section className="blog-section">
      <div className="blog-section__section-wrapper">
        {data.map((item, index) => (
          <div className="blog-section__card" key={item.slug || index}>
            <BlogCard 
              slug={item.slug} 
              image={item.coverImage}
              tag={item.tag}
              title={item.title}
              date={item.published}
            />
          </div>
        ))}

      {totalPages > 1 && (
        <div className="blog-section__pagination">
          {currentPage > 1 && (
            <Button text="Previous" type="secondary" onClick={handlePrev} />
          )}
          {currentPage < totalPages && (
            <Button text="Next" type="primary" onClick={handleNext} />
          )}
        </div>
      )}
      </div>
    </section>
  );
}

export default BlogSection;